import {Route, Routes } from 'react-router-dom'
import PageHeader from 'components/AppBar/PageHeader'
import { BasePathProvider } from 'components/Providers'
import { Box, Paper } from '@mui/material' 
import Incidents from './Incident'
import DisciplineTabs, { tabConfig } from './Tabs'
import RedirectToFirstPermitted from 'components/RedirectToPermittedTab'
import Protected from 'components/Protected'
import PageNotFound from 'pages/PageNotFound'

export default function Discipline() {
const basePath = '/discipline'
  return (
    <BasePathProvider value={`${basePath}/`}>
        <Box sx={{ mb: 2}}>
            <PageHeader title={'Discipline'} />
        </Box>
        <Paper sx={{width: '100%', minHeight: '500px', p: 2, mb: 2}}>
            <DisciplineTabs />
            <Routes>
                <Route path="/">
                    <Route index element={<RedirectToFirstPermitted basePath={basePath} items={tabConfig} />} />
                    <Route path={"incidents/*"} element={<Protected permission="discipline.incident"><Incidents /></Protected>} />
                    <Route path="*" element={<PageNotFound />} />
                </Route>
            </Routes>
        </Paper>
    </BasePathProvider>
  )
}
